import { render } from "./start-day.vue?vue&type=template&id=0413725c&lang=pug"
import script from "./start-day.vue?vue&type=script&setup=true&lang=js"
export * from "./start-day.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__